<template>
    <!-- 9577 file -->
    <ModalSide 
    class="application-modal" 
    ref="modal"
    @open="is_show_bg = true"
    @close="is_show_bg = false"
    >
        
        <Loading v-if="is_loading" class="static" />

        <header class="head" v-else>
            <div class="info">
                <h2>{{ info.name }}</h2>
                <p>ID:{{ info.unique_key ? info.unique_key : info.id }}</p>
            </div>
            <div :class="['btns', $store.state.merchant_disabeld && 'disabeld-box']">
                <tippy :placement="'left'" content="Refresh social insights" v-if="$store.state.user_data.is_motom_internal_user && type === 3">
                    <ui-button :class="[canNotEdit && 'not-allowed-btn']" color="white" size="32" :style="'bg-square'" @click="refrash">
                        <svg-icon name="refrash" />
                    </ui-button>
                </tippy>

                <ui-button color="black-10" size="32" :style="'bg-square'" :is_disabled="(!is_can_send_response && !is_can_send_invite )|| canNotEdit" @click="resend()">
                    <svg-icon name="email" />{{ is_can_send_invite ? 'Invite to Storefronts' : 'Send Response' }}
                </ui-button>
                
                <div :class="['application-active-menu',canNotEdit && 'not-allowed-btn']" :key="buttonKey">
                    <ui-button color="black-10" size="32" :style="'bg-square'" :class="'status-' + (info.is_auto_reject ? 'rejected' : strToSlug(info.decision_status_text))">
                        <template v-if="is_flexible && info.decision_status_text === 'Approved' && info.created_anchor_creator && !info.is_auto_reject">
                            <i v-if="info.created_anchor_creator.platform_type === 'storefront'"><svg-icon name="storefront" /></i>
                            <i v-else><svg-icon name="lightning" /></i>
                        </template>
                        {{ info.is_auto_reject ? 'Auto Reject' : info.decision_status_text }}
                        <svg-icon v-if="!$store.state.merchant_disabeld && !(info.decision_status === 100 && info.response_email_send_status === 100) && !info.is_auto_reject" name="down" />
                    </ui-button>
                    <ul v-if="!$store.state.merchant_disabeld && !(info.decision_status === 100 && info.response_email_send_status === 100) && !info.is_auto_reject">
                        <li v-for="(menu, index) in filtered_active_menu" :key="index" @click="updateDecisionStatus(menu)" :class="[{'current': menu.current}, {'disabled': menu.is_disabled},{ 'red-menu': menu.key===-10}]">
                            <span v-html="menu.current ? menu.text : menu.name"></span><svg-icon v-if="menu.current" name="yes-2" />
                        </li>
                    </ul>
                </div>
                <i class="close enabled-btn" @click="close">
                    <svg-icon name="close" />
                </i>
            </div>
        </header>

        <div class="application-wrap" v-if="!is_loading">
            <Scrollbar class="application-content" :show_bar="true">
                <nav class="application-menu">
                    <ul>
                        <li v-for="(menu, index) in menus" :key="index" @click="tab(menu.key)" :class="{'current': type === menu.key}">
                            <span v-html="menu.text"></span>
                        </li>
                    </ul>
                </nav>
                <Loading v-if="is_loading_data" class="static" />
                <div class="tab-content app-user-info" v-else-if="!is_loading_data && type === 1">
                    <h2>Creator Info</h2>
                    
                    <dl v-if="about.details">
                        <dt>Details</dt>
                        <dd class="full">
                            <span>Name</span>
                            <strong v-if="about.details.first_name || about.details.last_name">{{ about.details.first_name }} {{ about.details.last_name }}</strong>
                            <strong class="n-a" v-else>N/A</strong>
                        </dd>
                        <dd v-if="about.details.day_of_birth">
                            <span>Birthday</span>
                            <strong v-if="about.details.day_of_birth">{{ about.details.day_of_birth }}</strong>
                            <strong class="n-a" v-else>N/A</strong>
                        </dd>
                        <dd v-if="$ProjectName !== 'sephora' && about.details.age">
                            <span>Age</span>
                            <strong v-if="about.details.age">{{ about.details.age }}</strong>
                            <strong class="n-a" v-else>N/A</strong>
                        </dd>
                        <dd v-if="about.details.email">
                            <span>Email</span>
                            <strong v-if="about.details.email">{{ about.details.email }}</strong>
                            <strong class="n-a" v-else>N/A</strong>
                        </dd>
                        <dd v-if="about.details.prefer_name">
                            <span>Display name</span>
                            <strong v-if="about.details.prefer_name">{{ about.details.prefer_name }}</strong>
                            <strong class="n-a" v-else>N/A</strong>
                        </dd>
                        <dd v-if="about.details.pronouns">
                            <span>Pronouns</span>
                            <strong v-if="about.details.pronouns">{{ about.details.pronouns }}</strong>
                            <strong class="n-a" v-else>N/A</strong>
                        </dd>
                        <dd v-if="about.details.country">
                            <span>Country</span>
                            <strong v-if="about.details.country">{{ about.details.country }}</strong>
                            <strong class="n-a" v-else>N/A</strong>
                        </dd>
                        <dd v-if="about.details.ethnicity" style="width: 100%;">
                            <span>Ethnicity</span>
                            <strong v-if="about.details.ethnicity">{{ about.details.ethnicity }}</strong>
                            <strong class="n-a" v-else>N/A</strong>
                        </dd>
                    </dl>

                    <dl v-if="about.student_status && about.student_status.show" class="student-status">
                        <dt>Student status</dt>
                        <dd v-if="about.student_status.questions.attending_school.show">
                            <span>Attending school?</span>
                            <strong v-if="about.student_status.questions.attending_school.answer">{{ about.student_status.questions.attending_school.answer }}</strong>
                            <strong class="n-a" v-else>N/A</strong>
                        </dd>
                        <dd v-if="about.student_status.questions.school_college_university.show">
                            <span>School or College/University </span>
                            <strong v-if="about.student_status.questions.school_college_university.answer">{{ about.student_status.questions.school_college_university.answer }}</strong>
                            <strong class="n-a" v-else>N/A</strong>
                        </dd>
                        <dd v-if="about.student_status.questions.school_email.show">
                            <span>School email</span>
                            <strong v-if="about.student_status.questions.school_email.answer">{{ about.student_status.questions.school_email.answer }}</strong>
                            <strong class="n-a" v-else>N/A</strong>
                        </dd>
                        <dd v-if="about.student_status.questions.expected_gradation_date.show">
                            <span>Expected graduation date</span>
                            <strong v-if="about.student_status.questions.expected_gradation_date.answer">{{ about.student_status.questions.expected_gradation_date.answer }}</strong>
                            <strong class="n-a" v-else>N/A</strong>
                        </dd>
                    </dl>

                    <dl v-if="about.parent_guardian_consent && about.parent_guardian_consent.show">
                        <dt>Parent/garenden consent</dt>
                        <dd class="full" v-if="about.parent_guardian_consent.questions.parent_name.show">
                            <span>Parent name</span>
                            <strong v-if="about.parent_guardian_consent.questions.parent_name.answer">{{ about.parent_guardian_consent.questions.parent_name.answer }}</strong>
                            <strong class="n-a" v-else>N/A</strong>
                        </dd>
                        <dd v-if="about.parent_guardian_consent.questions.email.show">
                            <span>Email</span>
                            <strong v-if="about.parent_guardian_consent.questions.email.answer">{{ about.parent_guardian_consent.questions.email.answer }}</strong>
                            <strong class="n-a" v-else>N/A</strong>
                        </dd>
                        <dd v-if="about.parent_guardian_consent.questions.relationship.show">
                            <span>Relationship</span>
                            <strong v-if="about.parent_guardian_consent.questions.relationship.answer">{{ about.parent_guardian_consent.questions.relationship.answer }}</strong>
                            <strong class="n-a" v-else>N/A</strong>
                        </dd>
                        <dd class="full">
                            <span>Signed Disclaimer</span>
                            <p v-if="about.parent_guardian_consent.questions.signed_consent_disclaimer.show" class="checkbox"><svg-icon :name="about.parent_guardian_consent.questions.signed_consent_disclaimer.answer ? 'checked2' : 'checkbox'" />My parent/guardian and I have read and acknowledge the Parental/Guardian Consent Disclaimer.</p>
                            <p v-if="about.parent_guardian_consent.questions.signed_participate.show" class="checkbox"><svg-icon :name="about.parent_guardian_consent.questions.signed_participate.answer ? 'checked2' : 'checkbox'" />My parent/guardian agrees to allow me to participate in {{ name }}.</p>
                            <p v-if="about.parent_guardian_consent.questions.signed_privacy_policy.show" class="checkbox"><svg-icon :name="about.parent_guardian_consent.questions.signed_privacy_policy.answer ? 'checked2' : 'checkbox'" />My parent/guardian has read and acknowledges the {{ $store.state.user_data.merchant_account.merchant_display_name }} Terms & Conditions and Privacy Policy.</p>
                        </dd>
                    </dl>

                    <dl v-if="about.contact">
                        <dt>Contact</dt>
                        <dd class="full" v-if="about.contact.address || about.contact.city || about.contact.state || about.contact.zipcode">
                            <span>Address</span>
                            <strong v-if="about.contact.address || about.contact.city || about.contact.state || about.contact.zipcode">
                                {{ about.contact.address }}<br v-if="( about.contact.address && (about.contact.city || about.contact.state) )|| (about.contact.address && !about.contact.city && !about.contact.state && about.contact.zipcode)"/>
                                {{ about.contact.city }}, {{ about.contact.state }}<br v-if="(about.contact.city || about.contact.state) && about.contact.zipcode"/> {{ about.contact.zipcode }}
                            </strong>
                            <strong class="n-a" v-else>N/A</strong>
                        </dd>
                        <dd v-if="about.contact.email">
                            <span>Email</span>
                            <strong v-if="about.contact.email">{{ about.contact.email }}</strong>
                            <strong class="n-a" v-else>N/A</strong>
                        </dd>
                        <dd v-if="about.contact.phone">
                            <span>Phone</span>
                            <strong v-if="about.contact.phone">{{ about.contact.phone }}</strong>
                            <strong class="n-a" v-else>N/A</strong>
                        </dd>
                    </dl>
                    
                    <dl v-if="about.employment_status && about.employment_status.show">
                        <dt>Employment status</dt>
                        <dd class="full" v-if="about.employment_status.questions.current_staff.show">
                            <span>A current staff of your brand?</span>
                            <strong v-if="about.employment_status.questions.current_staff.answer">{{ about.employment_status.questions.current_staff.answer }}</strong>
                            <strong class="n-a" v-else>N/A</strong>
                        </dd>
                        <dd class="full" v-if="about.employment_status.questions.store_location.show">
                            <span>Store Location</span>
                            <strong v-if="about.employment_status.questions.store_location.answer">{{ about.employment_status.questions.store_location.answer }}</strong>
                            <strong class="n-a" v-else>N/A</strong>
                        </dd>
                        <dd v-if="about.employment_status.questions.store_id.show">
                            <span>Store ID</span>
                            <strong v-if="about.employment_status.questions.store_id.answer">{{ about.employment_status.questions.store_id.answer }}</strong>
                            <strong class="n-a" v-else>N/A</strong>
                        </dd>
                        <dd v-if="about.employment_status.questions.employee_id.show">
                            <span>Employee ID</span>
                            <strong v-if="about.employment_status.questions.employee_id.answer">{{ about.employment_status.questions.employee_id.answer }}</strong>
                            <strong class="n-a" v-else>N/A</strong>
                        </dd>
                    </dl>
                </div>

                <div class="tab-content" v-else-if="!is_loading_data && type === 2">
                    <ol class="responses">
                        <li v-for="(item, index) in responses" :key="index">
                            <h2>
                                <span>{{ index + 1 }}</span> 
                                {{ item.label_name }} 
                                <span class="disable" v-if="item.deleted_at">
                                    (Question removed {{ moment(item.deleted_at).format('MMM DD, YYYY') }})
                                </span>
                                <span class="disable" v-else-if="item.updated_at">
                                    (Question edited {{ moment(item.updated_at).format('MMM DD, YYYY') }})
                                </span>
                                <span class="disable" v-else-if="item.created_at">
                                    (Question added {{ moment(item.created_at).format('MMM DD, YYYY') }})
                                </span>
                            </h2>
                            <h3>{{ item.input_type_name }}</h3>
                            <div class="response">
                                <h4>Response</h4>
                                <template v-if="item.input_type === 'single_select' || item.input_type === 'multi_select'">
                                    <p class="checkbox" v-for="(o, index) in item.options" :key="index">
                                        <svg-icon :name="o.checked ? 'checked2' : 'checkbox'" /> {{ o.text }}
                                    </p>
                                </template>
                                <p v-else class="text" v-html="item.answer"></p>

                            </div>
                        </li>
                    </ol>
                </div>
                <SocialStats v-else-if="!is_loading_data && type === 3" :data_info="info" :ambassador_user_application_record_id="info.id" :is_app="true" />
            </Scrollbar>
            <Scrollbar class="application-sidebar">
                <div class="item">
                    <h3><svg-icon name="doc" /> Application Status</h3>
                    <div class="meta">
                        <strong>{{ moment(info.submitted).format('MMM DD, YYYY') }}</strong>
                        <p>Submitted</p>
                    </div>
                    <div class="meta" v-if="info.decision_status !== 0">
                        <strong>{{ moment(info.reviewed).format('MMM DD, YYYY') }}</strong>
                        <p>
                            Reviewed 
                            <tippy class="automated" :delay="[0, 20]" content="This applicant was automatically rejected because they did not meet the age requirement, follower count, or country criteria specified in the response settings." v-if="info.decision_status !== 0 && info.is_auto_reject">
                                (Automated)
                            </tippy>
                        </p> 
                    </div>
                    <div class="meta" v-if="info.decision_status !== 0" :class="'status-' + strToSlug(info.response_email_send_status_text)">
                        <strong class="status-text" v-if="info.response_email_send_status === 100">Sent <time>{{ moment(info.response_email_send_actions.show_date).format('MMM DD, YYYY') }}</time></strong>
                        <strong class="status-text" v-else-if="info.response_email_send_status === 10">{{ info.response_email_send_status_text }} <time>{{ scheduledResponseTime() }}</time> <span v-if="is_can_send_response && !$store.state.merchant_disabeld" :class="['blue', canNotEdit && 'not-allowed-btn']" @click="resend">Send</span></strong>
                        <strong class="status-text" v-else-if="info.response_email_send_status === 0">N/A <span v-if="(is_can_send_response && !$store.state.merchant_disabeld) || canNotEdit" :class="['blue',canNotEdit && 'not-allowed-btn']" @click="resend">Send decision</span></strong>
                        <strong class="status-text" v-else-if="info.response_email_send_status === -10">{{ info.response_email_send_status_text }} <span :class="['blue',canNotEdit && 'not-allowed-btn']" v-if="is_can_send_response && !$store.state.merchant_disabeld" @click="resend">Resend</span></strong>
                        <p>
                            <tippy :delay="[0, 20]" content="Indicates whether an email about the candidate's status has been dispatched, either approving or rejecting them. Once sent, the decision cannot be altered.">
                                Decision Email
                            </tippy>
                        </p>
                    </div>
                    <div class="meta" v-if="info.decision_status !== 0" :class="'status-' + strToSlug(info.storefront_invite_email_send_status_text)">
                        <strong class="status-text" v-if="info.storefront_invite_email_send_status === 100 || info.storefront_invite_email_send_status === 30">{{ info.storefront_invite_email_send_status_text }} <time>{{ moment(info.storefront_invite_email_send_actions.show_date).format('MMM DD, YYYY') }}</time></strong>
                        <strong class="status-text" v-else-if="info.storefront_invite_email_send_status === 10">{{ info.storefront_invite_email_send_status_text }} <time>{{ scheduledInviteTime() }}</time> <span v-if="is_can_send_invite" :class="['blue', canNotEdit && 'not-allowed-btn']" @click="resend">Send</span></strong>
                        <strong class="status-text" v-else-if="info.storefront_invite_email_send_status === 0">{{ info.storefront_invite_email_send_status_text }}</strong>
                        <strong class="status-text" v-else-if="info.storefront_invite_email_send_status === -10">{{ info.storefront_invite_email_send_status_text }} <span v-if="is_can_send_invite" :class="['blue',canNotEdit && 'not-allowed-btn']" @click="resend">Resend</span></strong>
                        <strong class="status-text" v-else-if="info.storefront_invite_email_send_status === 20">{{ info.storefront_invite_email_send_status_text }} <span v-if="is_can_send_invite" :class="['blue',canNotEdit && 'not-allowed-btn']" @click="resend">Send invite</span></strong>
                        <p>
                            <tippy :delay="[0, 20]" content="Shows the current status of the invite. Only applicants who have been approved and notified are eligible to receive an invite.">
                                Invite
                            </tippy>
                        </p>
                    </div>
                    <div class="auto-reject" v-if="info.decision_status !== 0 && info.is_auto_reject">
                        <strong>
                            <svg-icon name="question" /> Note
                        </strong>
                        <dl>
                            <dt>Auto-rejection reason(s):</dt>
                            <dd v-if="info.auto_reject_by_age">Age requirement not met</dd>
                            <dd v-if="info.auto_reject_by_location">Location criteria not met</dd>
                            <dd v-if="info.auto_reject_by_follower">Follower count not met</dd>
                        </dl>
                    </div>
                    <div class="meta" v-if="info.created_anchor_creator">
                        <strong>
                            {{ info.created_anchor_creator?.platform_type === 'linkonly' ? 'Links' : 'Storefront' }}
                        </strong>
                        <p>Account Type</p>
                    </div>
                </div>
                <div class="item" v-if="is_show_obj.is_show_tiktok_field">
                    <h3 :class="{'p' : !info.tiktok_handle}">
                        <svg-icon name="tiktok" /> 
                        <a v-if="info.tiktok_handle" target="_blank" :href="'https://www.tiktok.com/' + info.tiktok_handle">{{ info.tiktok_handle }}</a>
                        <span v-else>TikTok</span>
                    </h3>
                    <div class="meta" v-if="is_show_obj.is_show_tiktok_followers_field && info.tiktok_follower_count">
                        <strong>{{ handleNum(info.tiktok_follower_count) }}</strong> <span>Followers</span>
                    </div>
                    <div class="meta" v-else-if="info.tiktok_handle">
                        <a target="_blank" :href="'https://www.tiktok.com/' + info.tiktok_handle">{{ 'https://www.tiktok.com/' + info.tiktok_handle }}</a>
                    </div>
                    <div class="meta" v-else-if="is_show_obj.is_show_tiktok_followers_field">
                        <span>Not connected</span>
                    </div>
                </div>
                <div class="item" v-if="is_show_obj.is_show_instagram_field">
                    <h3 :class="{'p' : !info.instagram_handle}">
                        <svg-icon name="instagram" />
                        <a v-if="info.instagram_handle" target="_blank" :href="'https://www.instagram.com/' + info.instagram_handle">{{ '@' + info.instagram_handle }}</a>
                        <span v-else>Instagram</span>
                    </h3>
                    <div class="meta" v-if="is_show_obj.is_show_instagram_followers_field && info.instagram_follower_count">
                        <strong>{{ handleNum(info.instagram_follower_count) }}</strong> <span>Followers</span>
                    </div>
                    <div class="meta" v-else-if="info.instagram_handle">
                        <a target="_blank" :href="'https://www.instagram.com/' + info.instagram_handle">{{ 'https://www.instagram.com/' + info.instagram_handle }}</a>
                    </div>
                    <div class="meta" v-else-if="is_show_obj.is_show_instagram_followers_field">
                        <span>Not connected</span>
                    </div>
                </div>
                <div class="item" v-if="
                (
                    is_show_obj.is_show_youtube_field ||
                    is_show_obj.is_show_pinterest_field ||
                    is_show_obj.is_show_x_field ||
                    is_show_obj.is_show_twitch_field ||
                    is_show_obj.is_show_link_hub_field ||
                    is_show_obj.is_show_website_blog_field
                ) && (
                    info.youtube_url ||
                    info.pinterest_url ||
                    info.x_url ||
                    info.twitch_url ||
                    info.link_hub_url ||
                    info.website_blog_url
                )
                ">
                    <div class="meta" v-if="is_show_obj.is_show_youtube_field && info.youtube_url && info.youtube_url !== 'N/A'">
                        <h4>YouTube</h4>
                        <a target="_blank" :href="info.youtube_url">{{ info.youtube_url }}</a>
                    </div>
                    <div class="meta" v-if="is_show_obj.is_show_pinterest_field && info.pinterest_url && info.pinterest_url !== 'N/A'">
                        <h4>Pinterest</h4>
                        <a target="_blank" :href="info.pinterest_url">{{ info.pinterest_url }}</a>
                    </div>
                    <div class="meta" v-if="is_show_obj.is_show_x_field && info.x_url && info.x_url !== 'N/A'">
                        <h4>X</h4>
                        <a target="_blank" :href="info.x_url">{{ info.x_url }}</a>
                    </div>
                    <div class="meta" v-if="is_show_obj.is_show_twitch_field && info.twitch_url && info.twitch_url !== 'N/A'">
                        <h4>Twitch</h4>
                        <a target="_blank" :href="info.twitch_url">{{ info.twitch_url }}</a>
                    </div>
                    <div class="meta" v-if="is_show_obj.is_show_link_hub_field && info.link_hub_url && info.link_hub_url !== 'N/A'">
                        <h4>Link Hub</h4>
                        <a target="_blank" :href="info.link_hub_url">{{ info.link_hub_url }}</a>
                    </div>
                    <div class="meta" v-if="is_show_obj.is_show_website_blog_field && info.website_blog_url && info.website_blog_url !== 'N/A'">
                        <h4>Website/Blog</h4>
                        <a target="_blank" :href="info.website_blog_url">{{ info.website_blog_url }}</a>
                    </div>
                </div>
            </Scrollbar>
        </div>

    </ModalSide>
    <Transition name="fade">
        <div class="ui-modal-bg" v-if="is_show_bg"></div>
    </Transition>
</template>
<script>
import Loading from '@/components/ui/Loading.vue';
import ModalSide from '@/components/ui/ModalSide.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import SocialStats from '@/components/creator/SocialStats.vue';
// import NoData from '@/components/ui/NoData.vue';
import moment from 'moment';
// import Modal from '../ui/Modal.vue';
import { HandleNum, HandleKNum } from '@/utils/SwitchFun';

export default {
    name: 'ApplicationModalSide',

    components: {
        ModalSide,
        Loading,
        Scrollbar,
        SocialStats,
        // NoData,
        // Modal,
    },

    props: {
        info: {
            type: Object,
            default: {},
        },
        is_show_obj: {
            type: Object,
            default: {},
        },
        is_shortlink: {
            type: Boolean,
            default: false,
        },
        is_storefront: {
            type: Boolean,
            default: false,
        },
    },


    computed: {
        is_flexible() {
            return this.info.is_storefront && this.info.is_shortlink;
        },

        is_can_send_response() {
            return (this.info.decision_status === 100 || this.info.decision_status === -10) && this.info.response_email_send_status !== 100;
        },

        is_can_send_invite() {
            return this.info.decision_status === 100 && this.info.response_email_send_status === 100 && this.info.storefront_invite_email_send_status !== 30 && this.info.storefront_invite_email_send_status !== 100 && this.info.is_duplicate_anchor_creator_id === null;
        },
        permission_recruitment(){
            return this.$store.state.user_data?.permission_list?.recruitment;
        },
        canNotEdit(){
            return this.permission_recruitment?.approveOrRejectApplicants?.permission !== 100 || this.permission_recruitment?.manageCandidates?.permission !== 100;
        },

        is_link_only() {
            return this.$store.state.user_data?.merchant_account?.platform_type === 'linkonly';
        },

        filtered_active_menu() {
            if (this.info.decision_status === 100 || this.info.decision_status === 1) {
                let approvedShown = false;
                return this.active_menu.filter(item => {
                    if (item.key === 100 && item.current) {
                        if (approvedShown) return false;
                        approvedShown = true;
                    }
                    return true;
                });
            }
            return this.active_menu;
        },
    },

    data() {
        const is_link_only = this.$store.state.user_data?.merchant_account?.platform_type === 'linkonly';
        let approveMenus = [];
        
        if (is_link_only || (this.is_shortlink && !this.is_storefront)) {
            approveMenus = [ // IF: link only or shortlink only, show one approved menu
                { 
                    key: 100, 
                    name: 'Approve', 
                    text: 'Approved', 
                    current: true, 
                    class: 'approved', 
                    is_disabled: false, 
                    platform: 'shortlink'
                }
            ];
        } else if (this.is_storefront && this.is_shortlink) {
            approveMenus = [ // ELSE IF: both storefront and shortlink, show both approved menus with storefront as current by default
                {
                    key: 100,
                    name: 'Approve - Storefront',
                    text: 'Approved',
                    current: true,
                    class: 'approved',
                    is_disabled: false,
                    platform: 'storefront',
                },
                {
                    key: 100,
                    name: 'Approve - Links',
                    text: 'Approved',
                    current: false,
                    class: 'approved',
                    is_disabled: false,
                    platform: 'shortlink',
                },
            ];
        } else {
            approveMenus = [ // ELSE: show only storefront approved menu
                {
                    key: 100,
                    name: 'Approve',
                    text: 'Approved',
                    current: true,
                    class: 'approved',
                    is_disabled: false,
                    platform: 'storefront',
                }
            ];
        };

        return {
            type: 1,
            is_loading: false,
            is_loading_data: true,
            is_show_bg: false,
            // data: {},
            responses: [],
            about: [],
            // social_info: {},
            // info: false,
            menus: [
            ],
            active_menu: [
                { key: 0, name: 'To-Do', text: 'To-Do', current: false, class: 'todo', is_disabled: false, },
                ...approveMenus,
                { key: 10, name: 'Review', text: 'In Review', current: false, class: 'reviewing', is_disabled: false, },
                { key: 20, name: 'Waitlist', text: 'Waitlist', current: false, class: 'waitlist', is_disabled: false, },
                { key: -10, name: 'Reject', text: 'Rejected', current: false, class: 'rejected', is_disabled: false, },
            ],
            buttonKey:0,
        }
    },

    methods: {
        moment,
        handleNum: HandleNum,
        handleKNum: HandleKNum,

        pickPostmarkRecord(row, emailType) {
            const list = (row && row.postmark_send_email_records) || [];
            return list
                .filter(e => e.email_type === emailType)
                .sort((a, b) => new Date(b.schedule_send_datetime) - new Date(a.schedule_send_datetime))[0];
        },

        formatScheduledSendTime(datetime) {
            if (!datetime) return '';
            const target = moment.utc(datetime);
            const now = moment.utc();
            const diffMins = target.diff(now, 'minutes');
            const diffHours = target.diff(now, 'hours');
            const diffDays = target.diff(now, 'hours') / 24;

            if (diffDays > 1) return target.local().format('MMM DD, YYYY');
            if (diffHours > 1) return `in ${diffHours} hours`;
            return `in ${Math.max(0, diffMins)} mins`;
        },

        scheduledResponseTime() {
            const emailType = this.info.decision_status === 100 ? 'decision_approved' : 'decision_reject';
            const rec = this.pickPostmarkRecord(this.info, emailType);
            return this.formatScheduledSendTime(rec?.schedule_send_datetime);
        },

        scheduledInviteTime() {
            const rec = this.pickPostmarkRecord(this.info, 'storefront_invitation');
            return this.formatScheduledSendTime(rec?.schedule_send_datetime);
        },

        updateDecisionStatus(status) {
            if (status.is_disabled || status.current) return;

            //this.info.decision_status = status.key;
            // console.log('updateDecisionStatus', status);
            // return;
            //this.updateStatus();

            this.$emit('update-decision-status', {
                status: status,
                item: this.info,
                passfirst:false,
                isInsideChange:true
            });
        },

        refrash() {
            this.is_loading_data = true;
            this.$ajax.get(`/ambassador/get-application-user-record-detail/fetch-third-party-insight-api?ambassador_user_application_record_id=${this.info.id}`)
                .then(response => {
                    this.is_loading_data = false;
                });
        },

        resend(is_externally) {
            this.$emit('send-email', {
                type: is_externally ? (this.is_can_send_invite ? 'invite_externally' : 'response_externally') : (this.is_can_send_invite ? 'invite' : 'response'),
                item: this.info,
            });
        },

        updateStatus() {
            this.active_menu.forEach(item => {
                item.is_disabled = false;
                item.current = false;

                if (this.info.decision_status === 1 && item.key === 100) {
                    item.current = true;
                } else if (item.key === this.info.decision_status) {
                    item.current = true;
                }
                
                if (this.info.decision_status === 100 || this.info.decision_status === 1 || this.info.storefront_invite_email_send_status === 100) {
                    if (item.key !== 100) item.is_disabled = true;
                    if (this.info.decision_status === 1) this.info.decision_status = 100;
                } else if (this.info.decision_status === -10 || this.info.decision_status === 20) {
                    if (item.key === 0) item.is_disabled = true;
                }
            });

            switch(this.info.decision_status){
                case 0:
                    this.info.decision_status_text='To-Do'
                    break;
                case 100:
                    this.info.decision_status_text='Approved'
                    break;
                case 1:
                    this.info.decision_status_text='Approved'
                    break;
                case 10:
                    this.info.decision_status_text='Review'
                    break;
                case 20:
                    this.info.decision_status_text='Waitlist'
                    break;
                case -10:
                    this.info.decision_status_text='Rejected'
                    break;
            }

            this.buttonKey = true;
        },

        strToSlug(str) {
            str = str.replace(/[^\w\s]/g, '');
            return str.replace(/\s+/g, '-').toLowerCase();
        },

        tab(type) {
            this.is_loading_data = true;
            this.type = type;

            switch (this.type) {
                case 1:
                    // test id 17，18
                    // this.data.id = 17;
                    this.$ajax.get(`/ambassador/get-application-user-record-detail/about?ambassador_user_application_record_id=${this.info.id}`)
                        .then(response => {
                            // console.log(response.data.data);
                            this.about = response.data.data;
                            this.is_loading_data = false;
                        });
                    break;
                    
                case 2:
                    this.$ajax.get(`/ambassador/get-application-user-record-detail/response?ambassador_user_application_record_id=${this.info.id}`)
                        .then(response => {
                            this.responses = [];
                            response.data.data.custom_question.forEach(item => {
                                switch (item.input_type) {
                                    case 'single_select':
                                        item.input_type_name = 'Single choice';
                                        break;
                                    case 'multi_select':
                                        item.input_type_name = 'Multiple choice';
                                        break;
                                    case 'short_answer':
                                        item.input_type_name = 'Short answer';
                                        break;
                                    case 'long_answer':
                                        item.input_type_name = 'Long answer';
                                        break;

                                    default:
                                        item.input_type_name = item.input_type;
                                        break;
                                }

                                if (item.input_type === 'single_select' || item.input_type === 'multi_select') {
                                    item.options = [];
                                    item.input_option.forEach(o => {
                                        item.options.push({
                                            text: o,
                                            checked: item.answer.includes(o),
                                        });
                                    });
                                    // item.options = item.input_option.map(o => {
                                    //     o.checked = item.answer.includes(o.text);
                                    //     return o;
                                    // });
                                }

                                this.responses.push(item);
                            });

                            this.is_loading_data = false;
                        });
                    break;

                case 3:
                    this.is_loading_data = false;
                    break;
            }
        },

        open() {
            // console.log(this.is_show_obj)
            // this.getUserInfo();
            // this.info = false;
            this.about = [];
            this.responses = [];
            this.is_loading_data = true;

            this.menus = [
                {
                    text: 'About',
                    key: 1,
                },
            ];

            if (this.is_show_obj.is_show_responses_tab) {
                this.menus.push({
                    text: 'Responses',
                    key: 2,
                });
            }
            
            if (this.is_show_obj.is_show_social_insight) {
                this.menus.push({
                    text: 'Social Insights',
                    key: 3,
                });
            }

            this.updateStatus();

            this.tab(1);
            this.$refs.modal.open();
        },

        close() {
            this.$refs.modal.close();
        },
    },


}
</script>
<style lang="scss">
.application-modal {
    width: 100%;
    height: 100%;
    position: fixed;
    right: 0;
    top: 0;

    .ui-modal-side--container {
        background-color: var(--bg-10);
        padding: 0;
        display: grid;
        grid-template-rows: auto  1fr;
        grid-template-columns: 100%;
        
        .red-menu span{
            color:var(--red);
        }
    }

    .head {
        background-color: white;
        padding: 16px 24px;
        display: flex;
        align-items: center;
        box-shadow: var(--bot-2dp);

        .info {
            flex: 1;

            h2 {
                font: var(--font-med-24);
                margin-bottom: 4px;
            }

            p {
                font: var(--font-med-20);
                color: var(--black-50);
            }
        }

        .btns {
            display: flex;
            align-items: center;

            & > span > .ui-button {
                min-width: unset;
                width: 42px;
                height: 32px;
                padding: 0;
                display: flex;
                align-items: center;
                justify-content: center;

                svg {
                    width: 16px;
                    height: 16px;
                    margin: 0;
                }
            }

            .ui-button {
                margin-right: 8px;
                min-width: 120px;
                justify-content: center;

                .svg-icon--email {
                    width: 16px;
                    height: 16px;
                    margin-right: 6px;
                }

                .svg-icon--down {
                    width: 16px;
                    height: 16px;
                    margin-right: 0;
                    margin-left: 2px;
                }

                &.disabled {
                    display: none;
                }
            }

            .close {
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 32px;
                height: 32px;
                border-radius: 4px;
                transition: all .2s ease;
                margin-left: 8px;

                &:hover {
                    background-color: var(--black-10);
                }
                
                svg {
                    width: 12px;
                    height: 12px;
                }
            }
        }
    }

    .application-active-menu {
        position: relative;

        .ui-button {
            display: flex;
            align-items: center;
            border-radius: 6px;
            border: 1px solid transparent;
            font: var(--font-med-12);
            gap: 4px;

            &.status-todo {
                color: var(--black-90);
                background-color: var(--black-00);
                border-color: var(--black-20);
            }

            &.status-approved {
                color: var(--black-90);
                background-color: #A5E1BF;
                border-color: #A5E1BF;
            }

            &.status-rejected {
                color: var(--black-90);
                background-color: var(--Red-10);
                border-color: var(--Red-20);
            }

            &.status-reviewing {
                color: var(--black-90);
                background-color: var(--Yellow-10);
                border-color: var(--Yellow-30);
            }

            &.status-waitlist {
                color: var(--black-90);
                background-color: #D8F4FF;
                border-color: #7EA5F8;
            }

            .svg-icon--down {
                height: 16px;
                width: 16px;
                margin: 0;
            }

            .svg-icon--storefront,
            .svg-icon--lightning  {
                width: 12px;
                height: 12px;
                margin: 0;
            }
        }

        ul {
            position: absolute;
            right: 4px;
            top: 100%;
            z-index: 99;
            padding: 2px;
            background-color: var(--bg-01);
            width: 140px;
            border-radius: 6px;
            box-shadow: var(--bot-4dp);
            display: none;
        }

        &:hover ul {
            display: block;
        }

        li {
            cursor: pointer;
            display: flex;
            align-items: center;
            color: var(--black-60);
            padding: 8px 10px;
            border-radius: 4px;

            &:hover {
                background-color: var(--bg-02);
            }

            &.disabled {
                opacity: .5;
                pointer-events: none;
            }

            span {
                flex: 1;
                color: var(--black-90);
                font: var(--font-med-12);
            }

            svg {
                height: 12px;
                width: 12px;
            }
        }
    }

    .application-wrap {
        display: flex;
    }

    .application-content {
        flex: 1;
        height: calc(100vh - 88px);
    }

    .application-sidebar {
        width: 270px;
        max-width: 270px;
        min-width: 270px;
        box-shadow: var(--bot-2dp);
        position: relative;
        z-index: 3;
        background-color: white;
        height: calc(100vh - 88px);

        .item {
            padding: 16px;
            border-bottom: 1px solid var(--black-20);

            h3 {
                font: var(--font-med-16);
                margin-bottom: 16px;
                color: var(--black-90);
                display: flex;
                align-items: center;

                a {
                    color: var(--black-90);

                    &:hover {
                        text-decoration: underline;
                    }
                }

                svg {
                    width: 18px;
                    height: 18px;
                    margin-right: 8px;
                }

                &.p {
                    margin: 8px 0;
                }
            }

            strong {
                font: var(--font-med-14);
                color: var(--neutral-90);
            }

            p,
            span {
                color: var(--neutral-70);
            }

            .auto-reject {
                font-size: 12px;
                padding: 12px;
                margin-top: 16px;
                background-color: var(--bg-02);
                color: var(--neutral-60);

                strong {
                    display: flex;
                    align-items: center;
                    font: var(--font-med-12);
                    color: var(--black-90);
                    margin-bottom: 6px;

                    svg {
                        width: 10px;
                        height: 10px;
                        margin-right: 4px;
                    }
                }

                dl {
                    padding-left: 14px;

                    dd {
                        display: flex;
                        align-items: center;
                        margin: 1px 0;

                        &::before {
                            content: '';
                            height: 5px;
                            width: 5px;
                            border-radius: 50%;
                            margin: 0 6px;
                            background-color: var(--neutral-60);
                            display: block;
                        }
                    }
                }
                
            }

            .meta {
                margin-bottom: 12px;

                & > h4 {
                    font: var(--font-med-16);
                    color: var(--neutral-70);
                    margin-bottom: 8px;
                }


                & > a {
                    color: var(--blue);
                    cursor: pointer;
                    display: block;
                    overflow: hidden;
                    width: 100%;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-size: 12px;
                    margin-top: -8px;

                    &:hover {
                        text-decoration: underline;
                    }
                }

                .automated {
                    display: inline-flex;
                    align-items: center;
                    color: var(--black-50);
                    margin-left: 6px;

                    // svg {
                    //     height: 10px;
                    //     width: 10px;
                    //     margin-left: 4px;
                    //     display: block;
                    // }
                }

                &:last-child {
                    margin-bottom: 0;
                }

                .status-text {
                    display: flex;
                    align-items: center;

                    time {
                        margin-left: 10px;

                        &::before {
                            content: '(';
                        }

                        &::after {
                            content: ')';
                        }
                    }

                    .blue {
                        color: var(--blue);
                        cursor: pointer;
                        margin-left: 10px;
                    }
                }

                .status-text::before {
                    content: '';
                    height: 8px;
                    width: 8px;
                    border-radius: 50%;
                    margin-right: 4px;
                }

                &.status-na {
                    color: var(--neutral-60);

                    .status-text::before {
                        background: var(--black-40);
                    }
                }

                &.status-active,
                &.status-send,
                &.status-success {
                    .status-text::before {
                        background: var(--green);
                    }
                }

                &.status-failed {
                    .status-text::before {
                        background: var(--red);
                    }
                }
                
                &.status-ready,
                &.status-invited,
                &.status-scheduled {
                    .status-text::before {
                        background: var(--yellow);
                    }
                }
            }
        }
    }

    .application-menu {
        padding: 24px;

        ul {
            display: flex;
            align-items: center;

            li {
                cursor: pointer;
                font: var(--font-med-14);
                color: var(--black-50);
                transition: all .2s ease;
                margin-right: 16px;
                position: relative;
                padding-bottom: 8px;

                &:hover {
                    color: var(--black-90);
                }

                &.current {
                    color: var(--black-90);

                    &::after {
                        content: '';
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 100%;
                        height: 3px;
                        background-color: var(--dark-blue);
                        border-radius: 2px;
                    }
                }
            }
        }
    }

    .app-user-info {
        margin: 24px;
        
        & > h2 {
            font: var(--font-med-20);
            color: var(--black-90);
            margin-bottom: 16px;
        }

        dl {
            margin: 0 -4px 16px;
            display: flex;
            flex-wrap: wrap;

            &.student-status {
                dd:nth-child(2) {
                    width: calc(25% - 8px);
                }

                dd:nth-child(3) {
                    width: calc(75% - 8px);
                }
            }

            dt {
                font: var(--font-med-14);
                color: var(--black-50);
                margin-bottom: 8px;
                width: 100%;
                padding: 0 4px;
            }

            dd {
                padding: 12px;
                margin-bottom: 16px;
                box-sizing: border-box;
                margin: 4px;
                background-color: white;
                border: 1px solid rgba(#000, 0.08);
                width: calc(50% - 8px);


                &.full {
                    width: 100%;
                }

                span {
                    display: block;
                    font: var(--font-med-12);
                    color: var(--neutral-70);
                    margin-bottom: 8px;
                }

                strong {
                    font: var(--font-med-20);
                    color: var(--black-90);
                    display: block;

                    &.n-a {
                        color: var(--neutral);
                    }
                }

                p.checkbox {
                    display: flex;
                    align-items: center;
                    font: var(--font-med-14);
                    color: var(--black-90);
                    margin-top: 4px;

                    svg {
                        width: 14px;
                        height: 14px;
                        margin-right: 8px;
                    }
                }
            }
        }
    }

    .responses {
        margin: 0 24px;

        li {
            $margin: 32px;
            margin: 0 0 24px 0;

            h2 {
                font: var(--font-med-16);
                color: var(--black-90);
                margin-bottom: 8px;
                display: flex;
                align-items: center;

                span {
                    min-width: $margin;
                    width: $margin;
                }


                .disable {
                    font: var(--font-med-12);
                    color: var(--black-50);
                    margin-left: 8px;
                    white-space: nowrap;
                }
            }

            h3 {
                font: var(--font-med-12);
                color: var(--black-50);
                margin-bottom: 8px;
                margin-left: $margin;
            }

            .response {
                padding: 12px;
                background-color: white;
                margin-left: $margin;
            }

            h4 {
                font: var(--font-med-12);
                color: var(--black-50);
                margin-bottom: 8px;
            }

            .checkbox {
                display: flex;
                align-items: center;
                margin-bottom: 8px;
                color: var(--black-90);

                &:last-child {
                    margin-bottom: 0;
                }

                svg {
                    width: 14px;
                    height: 14px;
                    margin-right: 8px;
                }
            }

            .text {
                font: var(--font-med-16);
                color: var(--neutral-70);
            }
        }
    }

    .social-list-content {
        padding: 0 24px 24px;
    }

    .disabeld-box{
        opacity: .5;
    }
}

.ui-modal-bg {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 990;
    background-color: rgba(0, 0, 0, 0.5);
}
</style>